const config={
  app: {
    api:  '/data/school-counselling',
  },
  slider:{
    dots: false,
//    infinite: true,
//    swipe: true,
//      adaptiveHeight:true,
//    centerMode: true,
    speed: 6300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      { breakpoint: 768,  settings: { slidesToShow: 1, slidesToScroll: 1, autoplay:true } },
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, autoplay:false } }
    ]
  }
};

export default config;


// WEBPACK FOOTER //
// ./src/pages/school/config/config.js